import { CashbackDiscount, DiscountTypeEnum } from '@gamiphy/bl/cashbackDiscount';
import {
  AppCashbackDto, CampaignConfigDto, DiscountDto, PromotionCashbackDtoRewardTypeEnum, RewardConfigDtoTypeEnum,
  WelcomeGiftDto,
  WelcomeGiftDtoTypeEnum,
} from '@coretava/api/ecommerce-service';
import { WheelOptionDto, WheelOptionDtoRewardTypeEnum } from '@coretava/api/events-service';
import { TFunction } from '@gamiphy/react-i18n';
import { formatCurrencyNumber } from '@gamiphy/utils/number';
import { addDays } from 'date-fns';

export const formatDiscountValue = (discount: CashbackDiscount | DiscountDto): string => {
  if (discount.type === DiscountTypeEnum.Percentage) {
    return `${discount.value}%`;
  }
  return formatCurrencyNumber(discount.value);
};

export const formatCashbackPromotionValue = (appCashback: AppCashbackDto): string => (appCashback.promotion?.rewardType === PromotionCashbackDtoRewardTypeEnum.Monetary
  ? formatCurrencyNumber(appCashback.promotion.value) : `${appCashback.promotion?.value}%`);

export const formatWelcomeGiftValue = (welcomeGift: WelcomeGiftDto): string => (welcomeGift.type === WelcomeGiftDtoTypeEnum.Percentage
  ? `${welcomeGift.percentage}%` : formatCurrencyNumber(welcomeGift.monetary ?? 0));

export const formatCampaignReward = (campaign: CampaignConfigDto): string => (campaign.rewardConfig?.type === RewardConfigDtoTypeEnum.Percentage
  ? `${campaign.rewardConfig.value}%`
  : formatCurrencyNumber((campaign.rewardConfig?.value ?? 0)));

export const formatRefereeReward = (campaign: CampaignConfigDto): string => (campaign.rewardConfig?.type === RewardConfigDtoTypeEnum.Percentage
  ? `${campaign.booster?.refereeValue}%` : formatCurrencyNumber((campaign.rewardConfig?.value ?? 0)));

export const calculateBoosterEndDate = (campaign: CampaignConfigDto): Date => addDays(new Date(campaign.fromDate), campaign.booster?.expiredAfter ?? 0);

export const formatWheelOptionReward = (option: WheelOptionDto, t: TFunction): string | undefined => {
  switch (option.rewardType) {
    case WheelOptionDtoRewardTypeEnum.Monetary:
      return formatCurrencyNumber(option.value);
    case WheelOptionDtoRewardTypeEnum.Percentage:
      return `${option.value}%`;
    case WheelOptionDtoRewardTypeEnum.FreeShipping:
      return t('level.freeShipping', 'Free Shipping');
    default:
      return undefined;
  }
};
